
import template from './ko-field-view-percentage.html';

class PercentageComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);
	}
}


export default {
	name: 'ko-field-view-percentage',
	viewModel: PercentageComponentVM,
	module_type: 'ko',
	template: template
}
